import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
import { getFormatedDate } from "../../../common_components/user-task-card-view/user-task-utils";
import { getDefaultOptions } from "../../../utils/fetch";
export const GET_COMPLETED_AND_CANCELED_MY_TASKS = "GET_COMPLETED_AND_CANCELED_MY_TASKS";

export const service = async (data) => {
  const options: object = {
    url: `/Api/UserTasks/GetMyTasks`,
    method: "POST",
    ...getDefaultOptions(),
    body: JSON.stringify({
      clientTodayDate: getFormatedDate(new Date()),
      isForCompletedAndCanceledTab: true,
      ...data
    }),
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_COMPLETED_AND_CANCELED_MY_TASKS, service, mock);
